import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { Problems } from './components/Problems';
import { Chapters } from './components/Chapters';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { ContentPreview } from './components/ContentPreview';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { Objections } from './components/Objections';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1252242806993118');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Reviews data-id="element-2" />
      <Problems data-id="element-3" />
      <Chapters data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Comparison data-id="element-6" />
      <ContentPreview data-id="element-7" />
      <PurchaseSection data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Objections data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchasePopup data-id="element-12" />
    </div>;
}